import { render, staticRenderFns } from "./MyProceeds.vue?vue&type=template&id=1e85424a&scoped=true&"
import script from "./MyProceeds.vue?vue&type=script&lang=js&"
export * from "./MyProceeds.vue?vue&type=script&lang=js&"
import style0 from "./MyProceeds.vue?vue&type=style&index=0&id=1e85424a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85424a",
  null
  
)

export default component.exports